import Reaptcha from '@panalbish/reaptcha-enterprise';
import React, { useState } from 'react';
import Actions from '../../actions/actions';

export default function RecaptchaWidget({ onLoad, onVerify, onExpire, action }) {
  const [recaptchaRef, setRecaptchaRef] = useState(null);

  const onVerifyInterceptor = async (token) => {
    await Actions.setRecaptchaToken({ token });
    onVerify(token);
  };

  return (
    <div className="recaptcha-widget">
      <Reaptcha
        ref={(e) => setRecaptchaRef(e)}
        sitekey={process.env.REACT_APP_CAPTCHA_SITEKEY} // todo: devops load site key from secrets (build-time?)
        onLoad={() => onLoad(recaptchaRef)}
        onVerify={onVerifyInterceptor}
        onExpire={onExpire}
        enterprise={true}
        size="invisible"
        badge="inline"
        action={action}
      />
    </div>
  );
}
